/* ===================================================================
   DuraBilt Outdoors — Main JavaScript
=================================================================== */

// === HERO SLIDER ===
(function () {
  const hero = document.querySelector('.hero');
  if (!hero) return;

  const track      = hero.querySelector('.hero__track');
  const realSlides = Array.from(track.querySelectorAll('.hero__slide'));
  const total      = realSlides.length;
  if (total < 2) return;

  const doAutoplay = hero.dataset.autoplay !== 'false';
  const slideSpeed = parseInt(hero.dataset.speed) || 6000;
  const dots       = hero.querySelectorAll('.hero__dot');
  const prevBtn    = hero.querySelector('.hero__arrow--prev');
  const nextBtn    = hero.querySelector('.hero__arrow--next');

  // ── Infinite-loop: clone first+last slide ──────────────────
  // DOM after: [cloneLast(0)] [slide0(1)..slideN(total)] [cloneFirst(total+1)]
  const cloneFirst = realSlides[0].cloneNode(true);
  const cloneLast  = realSlides[total - 1].cloneNode(true);
  cloneFirst.setAttribute('aria-hidden', 'true');
  cloneLast.setAttribute('aria-hidden',  'true');
  track.appendChild(cloneFirst);
  track.insertBefore(cloneLast, realSlides[0]);

  let pos     = 1;   // DOM index; 1 = real slide 0
  let current = 0;   // logical index (for dots)
  let locked  = false;
  let timer;
  let startX  = 0;

  function snapTo(p) {
    track.style.transition = 'none';
    track.style.transform  = 'translateX(' + (-p * 100) + '%)';
    pos = p;
    void track.offsetWidth; // force reflow so transition restores correctly
  }

  function slideTo(p) {
    if (locked) return;
    locked = true;
    pos = p;
    // Logical current for dots: clamp to real range
    if (p <= 0)           current = total - 1;
    else if (p >= total + 1) current = 0;
    else                  current = p - 1;
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    track.style.transition = 'transform .72s cubic-bezier(.65,.05,.36,1)';
    track.style.transform  = 'translateX(' + (-p * 100) + '%)';
    manageVideos(p);
  }

  track.addEventListener('transitionend', function () {
    locked = false;
    if (pos >= total + 1) snapTo(1);     // cloneFirst → real slide 0
    else if (pos <= 0)    snapTo(total); // cloneLast  → real last slide
  });

  function forward()  { slideTo(pos + 1); resetTimer(); }
  function backward() { slideTo(pos - 1); resetTimer(); }

  function goTo(logical) {
    current = ((logical % total) + total) % total;
    slideTo(current + 1);
    resetTimer();
  }

  function manageVideos(p) {
    const children = track.children;
    for (let i = 0; i < children.length; i++) {
      const v = children[i].querySelector('video');
      if (!v) continue;
      if (i === p) v.play().catch(function () {});
      else { v.pause(); v.currentTime = 0; }
    }
  }

  function resetTimer() {
    clearInterval(timer);
    if (doAutoplay) timer = setInterval(forward, slideSpeed);
  }

  if (prevBtn) prevBtn.addEventListener('click', backward);
  if (nextBtn) nextBtn.addEventListener('click', forward);
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { goTo(i); });
  });

  hero.addEventListener('touchstart', function (e) {
    startX = e.touches[0].clientX;
  }, { passive: true });
  hero.addEventListener('touchend', function (e) {
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) diff > 0 ? forward() : backward();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft')  backward();
    if (e.key === 'ArrowRight') forward();
  });

  // Initialise at position 1 (real slide 0) silently
  snapTo(1);
  dots.forEach(function (d, i) { d.classList.toggle('is-active', i === 0); });
  manageVideos(1);
  if (doAutoplay) timer = setInterval(forward, slideSpeed);
})();

// === MARQUEE DEBUG ===
(function () {
  var marquee = document.querySelector('.marquee');
  var track   = document.querySelector('.marquee__track');

  console.group('[Marquee Debug]');

  if (!marquee) { console.error('❌ .marquee element NOT found in DOM'); console.groupEnd(); return; }
  if (!track)   { console.error('❌ .marquee__track NOT found in DOM'); console.groupEnd(); return; }
  console.log('✓ .marquee and .marquee__track found');

  var items = track.querySelectorAll('.marquee__item');
  console.log('Items in DOM:', items.length, '(expected: blocks × 4, e.g. 7 blocks → 28)');

  var trackW    = track.scrollWidth;
  var viewportW = window.innerWidth;
  console.log('Track scrollWidth:', trackW + 'px', '| Viewport:', viewportW + 'px');
  if (trackW < viewportW * 1.5) {
    console.warn('⚠ Track may be too narrow — add more blocks in Customizer');
  } else {
    console.log('✓ Track width OK for scrolling');
  }

  var cs = window.getComputedStyle(track);
  var animName  = cs.animationName;
  var animDur   = cs.animationDuration;
  var animState = cs.animationPlayState;
  console.log('animation-name:', animName);
  console.log('animation-duration:', animDur);
  console.log('animation-play-state:', animState);

  if (animName === 'none' || animName === '') {
    console.error('❌ animation-name is "none" — CSS not applied to .marquee__track. Check base.css is loaded.');
  } else if (animName === 'marquee-scroll') {
    console.log('✓ marquee-scroll animation is active');
    if (animState === 'paused') {
      console.warn('⚠ animation-play-state is paused — check prefers-reduced-motion or JS override');
    }
  } else {
    console.warn('Unknown animation-name:', animName);
  }

  if (animDur === '0s' || animDur === '') {
    console.error('❌ animation-duration is 0s or unset — section <style> tag may not have been applied');
  } else {
    console.log('✓ animation-duration:', animDur);
  }

  console.groupEnd();
})();

// === MARQUEE — 4 sets rendered in Liquid, no JS duplication needed ===
// Animation uses translateX(-25%) → exactly 1 of 4 sets → seamless loop

// === MOBILE NAV ===
(function () {
  var toggle  = document.querySelector('.site-header__mobile-toggle');
  var nav     = document.querySelector('.mobile-nav');
  var close   = document.querySelector('.mobile-nav__close');
  var overlay = document.querySelector('.mobile-nav__overlay');
  if (!toggle || !nav) return;

  function openNav() {
    nav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    nav.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', openNav);
  if (close)   close.addEventListener('click', closeNav);
  if (overlay) overlay.addEventListener('click', closeNav);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) closeNav();
  });
})();

// === PRODUCT GALLERY (PDP) ===
(function () {
  var thumbs = document.querySelectorAll('.product-gallery__thumb');
  var mainImg = document.querySelector('.product-gallery__main img');
  if (!thumbs.length || !mainImg) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src  = thumb.dataset.src;
      var srcset = thumb.dataset.srcset;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (src) mainImg.src = src;
      if (srcset) mainImg.srcset = srcset;
    });
  });
})();

// === VARIANT SELECTOR (PDP) ===
(function () {
  var variantBtns = document.querySelectorAll('.variant-btn');
  var variantInput = document.querySelector('input[name="id"]');
  if (!variantBtns.length) return;

  variantBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.product-form__variants');
      group.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      if (variantInput && btn.dataset.variantId) {
        variantInput.value = btn.dataset.variantId;
      }
    });
  });
})();

// === ADD TO CART (AJAX) ===
(function () {
  var forms = document.querySelectorAll('.product-form[data-ajax-cart]');
  forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.product-form__atc');
      var original = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added ✓';
        updateCartCount();
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 2200);
      })
      .catch(function () {
        btn.textContent = original;
        btn.disabled = false;
      });
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.site-header__cart-count').forEach(function (el) {
        el.textContent = '(' + cart.item_count + ')';
      });
    });
  }
})();

// === REVIEWS SLIDER ===
(function () {
  var sliders = document.querySelectorAll('[data-reviews-slider]');
  sliders.forEach(function (slider) {
    var track   = slider.querySelector('.reviews-slider__track');
    var dots    = slider.querySelectorAll('.reviews-slider__dot');
    var prevBtn = slider.querySelector('.reviews-slider__arrow--prev');
    var nextBtn = slider.querySelector('.reviews-slider__arrow--next');

    var doAutoplay = slider.dataset.autoplay !== 'false';
    var speed      = parseInt(slider.dataset.speed) || 5000;
    var cardsUp    = parseInt(slider.dataset.cards) || 2;

    var realCards = Array.prototype.slice.call(slider.querySelectorAll('.review-card'));
    var total     = realCards.length;
    if (total < 2) return;

    // Clone first N cards so last position always shows full row
    for (var c = 0; c < cardsUp; c++) {
      if (realCards[c]) {
        var clone = realCards[c].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }
    }

    var current = 0;
    var startX  = 0;
    var timer;

    function goTo(idx) {
      current = ((idx % total) + total) % total;
      var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      var px  = current * (realCards[0].offsetWidth + gap);
      track.style.transform = 'translateX(-' + px + 'px)';
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) goTo(current + (diff > 0 ? 1 : -1));
    });

    function startTimer() { if (doAutoplay) timer = setInterval(function () { goTo(current + 1); }, speed); }
    function stopTimer()  { clearInterval(timer); }

    slider.addEventListener('mouseenter', stopTimer);
    slider.addEventListener('mouseleave', startTimer);
    window.addEventListener('resize', function () { goTo(current); });

    startTimer();
    goTo(0);
  });
})();

// === STICKY HEADER SHADOW ===
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', function () {
    header.classList.toggle('is-scrolled', window.scrollY > 20);
  }, { passive: true });
})();

// === SCROLL ANIMATIONS ===
(function () {
  if (!('IntersectionObserver' in window)) return;

  var targets = document.querySelectorAll(
    '.sec-head, .product-card, .split-panel, .comp-table, .comp-note'
  );
  if (!targets.length) return;

  var vh = window.innerHeight;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  targets.forEach(function (el) {
    var top = el.getBoundingClientRect().top;
    if (top < vh * 0.95) {
      // Already visible on page load — skip animation to avoid flicker
      return;
    }
    el.classList.add('anim-up');
    io.observe(el);
  });
})();

// === NEWSLETTER FORM ===
(function () {
  var form = document.querySelector('.sign-form');
  if (!form) return;
  var success = form.nextElementSibling;

  form.addEventListener('submit', function (e) {
    var email = form.querySelector('input[type="email"]');
    if (!email || !email.value) { e.preventDefault(); return; }
    // Shopify handles submission natively; show success on page reload via URL param
    if (window.location.search.includes('customer_posted=true') && success) {
      success.style.display = 'block';
      form.style.display = 'none';
    }
  });

  if (window.location.search.includes('customer_posted=true') && success) {
    success.style.display = 'block';
    form.style.display = 'none';
  }
})();
